import type Fuse from 'fuse.js';

import type {OmniboxFilter} from 'omnibox/useTypeaheadData';

import {MAX_TYPEAHEAD_RESULTS, getModelTypeDisplayName} from './omniboxConstants';

export function extractFilterParams(selectedFilters: Array<{kind: string; id: string}>): {
  schemaApiIds: Array<string>;
  objectTypes: Array<string>;
  projectApiIds: Array<string>;
  folderApiIds: Array<string>;
  authorApiIds: Array<string>;
} {
  return {
    schemaApiIds: selectedFilters.filter((f) => f.kind === 'schema').map((f) => f.id),
    objectTypes: selectedFilters.filter((f) => f.kind === 'type').map((f) => f.id),
    projectApiIds: selectedFilters.filter((f) => f.kind === 'project').map((f) => f.id),
    folderApiIds: selectedFilters.filter((f) => f.kind === 'folder').map((f) => f.id),
    authorApiIds: selectedFilters.filter((f) => f.kind === 'user').map((f) => f.id),
  };
}

const FILTER_CHIP_PREFIXES: Record<OmniboxFilter['kind'], string> = {
  user: 'Authored by',
  project: 'In',
  folder: 'In',
  type: 'Type',
  schema: 'Type',
};

export function getFilterChipLabel(filter: OmniboxFilter): string {
  return `${FILTER_CHIP_PREFIXES[filter.kind]}: ${filter.name}`;
}

export function getFilterDescription(item: OmniboxFilter): string | undefined {
  if (item.kind === 'user') {
    return item.isSelf ? 'You' : `@${item.handle}`;
  }
  if (item.kind === 'project' || item.kind === 'folder') {
    return item.projectName;
  }
  if (item.kind === 'schema' && item.modelType) {
    return getModelTypeDisplayName(item.modelType);
  }
  return undefined;
}

export function filterAndSearchTypeahead(
  items: Array<OmniboxFilter>,
  fuseInstance: Fuse<OmniboxFilter>,
  query: string,
  selectedIds: Set<string>,
  maxResults: number = MAX_TYPEAHEAD_RESULTS
): Array<OmniboxFilter> {
  if (!query) {
    return items.filter((item) => !selectedIds.has(`${item.kind}:${item.id}`)).slice(0, maxResults);
  }
  return fuseInstance
    .search(query)
    .map((r) => r.item)
    .filter((item) => !selectedIds.has(`${item.kind}:${item.id}`))
    .slice(0, maxResults);
}
